// /var/www/afra/192.testproject.work/maracar8/0.8.2/myapp/src/utils/HandlersMember.js

import { API_URLS } from '../api/api';

export const fetchMemberData = async (userId, token) => {
  if (!userId || !token) {
    throw new Error('User ID or Token is missing');
  }
  try {
    const apiUrl = API_URLS.ALL_USERS(userId);
    const response = await fetch(apiUrl, {
      headers: {
        'Authorization': `Bearer ${token}`,
      },
    });

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({ message: 'Failed to fetch members' }));
      throw new Error(errorData.message || 'Network response was not ok');
    }

    const data = await response.json();
    return Array.isArray(data) ? data : (data ? [data] : []);
  } catch (error) {
    console.error('Fetch error:', error);
    throw error;
  }
};

export const fetchPositions = async (token) => {
  if (!token) {
    throw new Error('Token is missing');
  }
  try {
    const response = await fetch(API_URLS.POSITION_LIST, {
      headers: {
        'Authorization': `Bearer ${token}`
      }
    });
    if (!response.ok) {
      const errorData = await response.json().catch(() => ({ message: 'Failed to fetch positions' }));
      throw new Error(errorData.message || 'Failed to fetch positions');
    }
    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error fetching positions:', error);
    throw error;
  }
};

export const updateRole = async (userId, newPositionId, token) => {
  if (!token) {
    throw new Error('Token is missing');
  }
  try {
    const apiUrl = API_URLS.POSITION_SET(userId);
    const response = await fetch(apiUrl, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      },
      body: JSON.stringify({ position_ID: newPositionId }),
    });

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({ message: 'Failed to update position' }));
      throw new Error(errorData.message || 'Failed to update position');
    }
  } catch (error) {
    console.error('Error updating position:', error);
    throw error;
  }
};

export const updateStatus = async (userId, newStatusId, token) => {
  if (!token) {
    throw new Error('Token is missing');
  }
  try {
    const apiUrl = API_URLS.UPDATE_STATUS(userId);
    const response = await fetch(apiUrl, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      },
      body: JSON.stringify({ status_ID: newStatusId }),
    });

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({ message: 'Failed to update status' }));
      throw new Error(errorData.message || 'Failed to update status');
    }
  } catch (error) {
    console.error('Error updating status:', error);
    throw error;
  }
};